import global$1 from '../internals/global.js';
import descriptors from '../internals/descriptors.js';
import regexpUnsupportedDotAll from '../internals/regexp-unsupported-dot-all.js';
import classofRaw from '../internals/classof-raw.js';
import '../internals/object-define-property.js';
import internalState from '../internals/internal-state.js';
import { __exports as objectDefineProperty } from '../../../../../../_virtual/object-define-property.js';

var global = global$1;
var DESCRIPTORS = descriptors;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var classof = classofRaw;
var defineProperty = objectDefineProperty.f;
var getInternalState = internalState.get;
var RegExpPrototype = RegExp.prototype;
var TypeError = global.TypeError; // `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall

if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineProperty(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function () {
      if (this === RegExpPrototype) return undefined; // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.

      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }

      throw TypeError('Incompatible receiver, RegExp required');
    }
  });
}
